(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('load', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

hide() {
  if (this.headerIsAlwaysSticky) return;
  if (window.innerWidth >= 990) return;
  this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  this.closeMenuDisclosure();
  this.closeSearchModal();
}

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Smart Search Handler
  document.addEventListener('DOMContentLoaded', function() {
    const excludedTemplates = [
      'customers/login',
      'customers/register',
      'customers/reset_password',
      'customers/account',
      'customers/addresses',
      'customers/order'
    ];

    const excludedPaths = [
      '/account/login',
      '/account/register',
      '/account',
      '/account/addresses',
      '/account/reset'
    ];

    const template = document.body.getAttribute('data-template') || '';
    const currentPath = window.location.pathname;
    
    const shouldHideByTemplate = excludedTemplates.some(excluded => template.includes(excluded));
    const shouldHideByPath = excludedPaths.some(path => currentPath.includes(path));
    
    if (shouldHideByTemplate || shouldHideByPath) {
      document.body.classList.add('hide-smart-search');
    }

    const toggleMobile  = document.getElementById('smart-search-toggle');
    const toggleDesktop = document.getElementById('smart-search-toggle-desktop');
    const closeBtn      = document.getElementById('smart-search-close');
    const headerElement = document.querySelector('.section-header');

    function openSearch(e) {
      e.preventDefault(); e.stopPropagation();
      if (!headerElement) return;
      headerElement.classList.add('search-expanded');
      const searchInput = document.getElementById('Search-In-Header');
      if (searchInput) { setTimeout(function() { searchInput.focus(); }, 100); }
    }

    function closeSearch(e) {
      e.preventDefault(); e.stopPropagation();
      if (!headerElement) return;
      headerElement.classList.remove('search-expanded');
      const searchInput = document.getElementById('Search-In-Header');
      if (searchInput) { searchInput.value = ''; searchInput.blur(); }
    }

    if (toggleMobile)  toggleMobile.addEventListener('click', openSearch);
    if (toggleDesktop) toggleDesktop.addEventListener('click', openSearch);
    if (closeBtn)      closeBtn.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && headerElement && headerElement.classList.contains('search-expanded')) {
        closeSearch({ preventDefault: function(){}, stopPropagation: function(){} });
      }
    });

    document.addEventListener('click', function(e) {
      if (!headerElement) return;
      const searchContainer = headerElement.querySelector('.header__search');
      if (headerElement.classList.contains('search-expanded')) {
        const inSearch  = searchContainer && searchContainer.contains(e.target);
        const inMobile  = toggleMobile  && toggleMobile.contains(e.target);
        const inDesktop = toggleDesktop && toggleDesktop.contains(e.target);
        if (!inSearch && !inMobile && !inDesktop) {
          closeSearch({ preventDefault: function(){}, stopPropagation: function(){} });
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
